import React, { lazy, Suspense } from 'react';

const LazyPreviousOrderMco = lazy(() => import('./PreviousOrderMco'));

const PreviousOrderMco = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyPreviousOrderMco {...props} />
  </Suspense>
);

export default PreviousOrderMco;
